<template>
<main class="main-window">
  <top-bar v-if="showTopBar" />
  <div class="main-content">
    <router-view/>
  </div>
</main>
</template>
<script>
import TopBar from './TopBar'

export default {

  components: {
    TopBar
  },

  computed: {
    showTopBar() {
      if(this.$route.name == 'login' || this.$route.name == 'signup' || this.$route.name == 'device') return false
      return true
    }
  }
  
}
</script>